<ng-container [formGroup]="formGroup" *ngIf="formGroup">
  <nz-form-control
    [nzErrorTip]="countryErrorTpl"
    [ngClass]="{
      'has-error':
        formGroup.get(controlName).errors && formGroup.get(controlName).dirty
    }"
  >
    <nz-input-group [nzSuffix]="suffixIcon">
      <input
        nz-input
        [formControlName]="controlName"
        [nzAutocomplete]="auto"
        [placeholder]="'FORM.LABEL.SELECT_COUNTRY' | translate"
        (ngModelChange)="onChange($event)"
      />
      <nz-autocomplete #auto>
        <nz-auto-option
          *ngFor="let country of filteredOptions"
          [nzValue]="country.value"
          [nzLabel]="country.text"
        >
          {{ country.text }}
        </nz-auto-option>
      </nz-autocomplete>
    </nz-input-group>
    <ng-template #countryErrorTpl let-control>
      <ng-container *ngIf="control.hasError('required')">
        {{ "FORM.ERR.REQUIRED_COUNTRY" | translate }}
      </ng-container>
      <ng-container *ngIf="control.hasError('notIncludedIn')">
        {{ "FORM.ERR.VALID_COUNTRY" | translate }}
      </ng-container>
    </ng-template>
    <ng-template #suffixIcon>
      <i nz-icon nzType="search"></i>
    </ng-template>
  </nz-form-control>
</ng-container>
